import { useEffect, useState } from 'react';
import { Button, H2, Paragraph, Separator, Spinner, Text, YStack } from 'tamagui';
import type { AuthUser } from '@mrrmlab/auth';
import { useAppAuth } from '../app-context';
import { useSignOut } from '../hooks/use-sign-out';

export function KontoRoute() {
  const auth = useAppAuth();
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);
  const { signOut, pending: loggingOut } = useSignOut();

  useEffect(() => {
    if (!auth) { setLoading(false); return; }
    auth.getUser().then(u => { setUser(u); setLoading(false); });
  }, [auth]);

  if (loading) {
    return (
      <YStack flex={1} alignItems="center" justifyContent="center" padding="$6">
        <Spinner size="large" />
      </YStack>
    );
  }

  return (
    <YStack padding="$4" gap="$4" maxWidth={480}>
      <H2>Konto</H2>

      {user ? (
        <YStack gap="$2" padding="$4" borderRadius="$4" borderWidth={1} borderColor="$borderColor">
          {user.name ? (
            <Text fontSize="$6" fontWeight="700">{user.name}</Text>
          ) : null}
          {user.preferredUsername ? (
            <Text fontSize="$4" color="$color11">{user.preferredUsername}</Text>
          ) : null}
          {user.email ? (
            <Text fontSize="$3" color="$color10">{user.email}</Text>
          ) : null}
        </YStack>
      ) : (
        <Paragraph color="$color10">Kein Nutzer angemeldet.</Paragraph>
      )}

      <Separator />

      <Button
        onPress={signOut}
        disabled={loggingOut}
        theme="red"
        alignSelf="flex-start"
      >
        {loggingOut ? <Spinner /> : 'Abmelden'}
      </Button>
    </YStack>
  );
}
